import React from 'react';
import classnames from 'classnames';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './Checkmark.scss';

type Props = {
  isCompleted: boolean;
  onClick?: () => void;
};

const Checkmark = ({ isCompleted, onClick }: Props) => {
  const handdleClick = () => {
    if (onClick) onClick();
  };
  const baseClassName = 'Checkmark';
  const classes = classnames(
    baseClassName,
    onClick && `${baseClassName}--clickable`,
    isCompleted && `${baseClassName}--completed`
  );
  return (
    <div className={classes} onClick={handdleClick}>
      {isCompleted ? <WpIcon name="check-circle" prefix="fas" /> : <WpIcon name="check-circle" />}
    </div>
  );
};

export default Checkmark;
